import { configFile } from "@/config";
import { HeaderMenuData } from "@/Types/types";
import {
  Flex,
  Link as ChakraLink,
} from "@chakra-ui/react";
import Link from "next/link";
import React from "react";

export default function DesktopNav({ menu }: { menu: HeaderMenuData[] }) {
  return (
    <Flex
      align="center"
      columnGap="32px"
      as="nav"
      display={{ base: "none", lg: "flex" }}
    >
      {menu.map((item: HeaderMenuData) => (
        <ChakraLink
          href={item.path}
          key={item.id}
          fontWeight={600}
          color="#1A202C"
          _hover={{ color: configFile.secondaryAccentColor }}
          _last={{
            bgColor: configFile.primaryAccentColor,
            color: "#fff",
            borderRadius: "8px",
            pt: "8px",
            pb: "8px",
            pr: "16px",
            pl: "16px",
            _hover: { background: configFile.secondaryAccentColor },
          }}
          as={Link}
        >
          {item.title}
        </ChakraLink>
      ))}
    </Flex>
  )
}
